export function init() {
    const containers = document.querySelectorAll(".raw-html-embed");

    containers.forEach((container) => {
        // If container has an iframe that contains a src with youtube or vimeo in the URL
        // we can apply a class to the iframe to set a 16:9 aspect ratio
        const iframe = container.querySelector("iframe");

        if (iframe) {
            const src = iframe.getAttribute("src");
            if (src.includes("youtube") || src.includes("vimeo")) {
                iframe.classList.add("video-aspect-ratio");
            }
        }
    });
}
